export var dateInputMask = function (e, value, setValue, picker) {
    if (isNaN(Number(e.key))) {
        e.preventDefault();
    }
    var newValue = value;
    var len = value.length;
    if (len === 2) {
        newValue += '/';
    }
    if (picker === 'date' && len === 5) {
        newValue += '/';
    }
    setValue(newValue);
};
export var getFormatedDate = function (date, picker) {
    if (picker === void 0) { picker = 'date'; }
    if (!date) {
        return '';
    }
    var padTo2Digits = function (num) {
        return num.toString().padStart(2, '0');
    };
    if (picker === 'month') {
        return [padTo2Digits(date.getMonth() + 1), date.getFullYear()].join('/');
    }
    else {
        return [
            padTo2Digits(date.getDate()),
            padTo2Digits(date.getMonth() + 1),
            date.getFullYear(),
        ].join('/');
    }
};
export var isWeekend = function (date) {
    var day = date.getDay();
    return day === 0 || day === 6;
};
export var isAvalidDate = function (value, disableWeekend, picker, minDate, maxDate) {
    if (value === '' ||
        (picker === 'date' && value.length < 10) ||
        (picker === 'month' && value.length < 7)) {
        return false;
    }
    var _a = getDateValues(value, picker), day = _a.day, month = _a.month, year = _a.year;
    var date = new Date(year, month, day);
    return (month >= 0 &&
        month < 12 &&
        day > 0 &&
        day <= daysInMonth(month, year) &&
        year < 2200 &&
        year > 1900 &&
        (!minDate || (!!minDate && date.getTime() >= minDate.getTime())) &&
        (!maxDate || (!!maxDate && date.getTime() <= maxDate.getTime())) &&
        (!disableWeekend ||
            picker === 'month' ||
            (disableWeekend && !isWeekend(date))));
};
export var getDateValues = function (dateText, picker) {
    if (picker === 'month') {
        var day = 1;
        var month = Number(dateText.substring(0, 2)) - 1;
        var year = Number(dateText.substring(3, 8));
        return { day: day, month: month, year: year };
    }
    else {
        var day = Number(dateText.substring(0, 2));
        var month = Number(dateText.substring(3, 5)) - 1;
        var year = Number(dateText.substring(6, 11));
        return { day: day, month: month, year: year };
    }
};
var daysInMonth = function (m, y) {
    switch (m) {
        case 1:
            return (y % 4 == 0 && y % 100) || y % 400 == 0 ? 29 : 28;
        case 3:
        case 5:
        case 8:
            return 30;
        case 10:
        default:
            return 31;
    }
};
export var getDefaultActiveStartDate = function (isRange, value, maxDate) {
    if (isRange && !!value) {
        return value[1] || maxDate;
    }
    else if (!isRange) {
        return value || maxDate;
    }
};
export var resetHoursFromDate = function (date) {
    date.setHours(0, 0, 0, 0);
    return date;
};
